import React, { useState } from 'react'
import { useParams, useHistory } from 'react-router-dom'
import moment from 'moment'

// utils
import { setScheduleDateRange } from './Schedule.utils'

// components
import ActionButton from '../../../components/buttons/ActionButton/ActionButton.component'

// collections
import ScheduleWeek from './collections/ScheduleWeek.collection'

// forms
import CreateJobDayFormController from './forms/createJobDay/CreateJobDay.form.controller'

// styles
import './Schedule.styles.css'

// mui
import { Grid, Container, Typography } from '@mui/material'
import ChevronRightIcon from '@mui/icons-material/ChevronRight'
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'

// utils
import { createUserGroupList } from '../../../shared/privileges/userGroups'

export default function Schedule({ usersGroups }) {

    const groups = createUserGroupList(usersGroups)

    // dates
    let history = useHistory()
    const { startDateString } = useParams()
    let dateRange = setScheduleDateRange(startDateString)
    const startDate = dateRange.startDate
    const endDate = dateRange.endDate

    // modals
    const [showAddModal, setShowAddModal] = useState(false)

    return (<div id="Calendar">
        <CreateJobDayFormController
            visible={showAddModal}
            closeForm={() => setShowAddModal(false)}
        />

        <Container maxWidth sx={{ marginBottom: 4}} disableGutters>
            <Grid container spacing={2} justifyContent="space-between" alignItems={'center'}>
                <Grid item xs={3}><Typography variant="h2">Schedule</Typography></Grid>
                <Grid container item xs={6} spacing={2} alignItems='center' justifyContent={'center'}>

                    <Grid item sx={4}>
                        <ActionButton label={<ChevronLeftIcon />} color="secondary" onClick={() => {
                            history.push(`/schedule/${moment(startDate).subtract(7, 'days').format("YYYY-MM-DD")}`)
                        }}/>
                    </Grid>
                    <Grid item sx={4}><Typography>{startDate} - {endDate}</Typography></Grid>
                    <Grid item sx={4}>
                        <ActionButton label={<ChevronRightIcon />} color="secondary" onClick={() => {
                            history.push(`/schedule/${moment(startDate).add(7, 'days').format("YYYY-MM-DD")}`)
                        }}/>
                    </Grid>
                </Grid>
                <Grid item xs={3} textAlign='right'>
                {
                    (groups.includes("ForemanWithLimitedAdminAccess") || groups.includes("Admin")) 
                    && <ActionButton label="New Job Day" onClick={() => setShowAddModal(true)} />
                }
                </Grid>
            </Grid>
        </Container>

        <ScheduleWeek startDate={moment(startDate).format("YYYY-MM-DD")} endDate={moment(endDate).format("YYYY-MM-DD")} />
    </div>)
}